import { Component } from '@angular/core';

@Component({
    selector: 'login-required-error',
    templateUrl: './login-required-error.component.html',
    styleUrls: ['./login-required-error.component.scss'],
    standalone: false
})
export class LoginRequiredErrorComponent {}
